export const TOTAL_SYLLABUS_WEEKS = 12;

export interface SelectOption {
  value: number | string;
  label: string;
}

export const rowsPerPageOptions: SelectOption[] = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

export const courseStatusOptions: SelectOption[] = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const courseLevelOptions: SelectOption[] = [
  { value: "Beginner", label: "Beginner" },
  { value: "Intermediate", label: "Intermediate" },
  { value: "Advanced", label: "Advanced" },
];

